import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Link } from "react-router-dom";
const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;
export const LeaderBoard = (props) => {
  const { userData } = props;

  const [value, setValue] = useState("1");
  const [leaderboardData, setLeaderboardData] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    getLeaderboardData(newValue);
  };

  useEffect(() => {
    getLeaderboardData(1);
  }, []);

  const getLeaderboardData = async (tabValue) => {
    try {
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GetWeeklyLeaderboard?Mobile=empty&name=empty&IsWeeklyLeaderboard=${tabValue}&pageNumber=1&pageSize=8`,
        {
          method: "GET",
        }
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);

      const responseData = await response.json();
      setLeaderboardData(responseData?.result || []);
    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
    }
  };

  return (
    <div className="leaderBoardWrapper mt-5" id="leaderBoards">
      <h1 className="text-center">
        Check <span>Winner’s</span> Leaderboard!
      </h1>
      <div className="leaderBoardContainer mt-3">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                indicatorColor="transparent"
                className="justify-content-center"
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="This Week" value="1" />
                <Tab label="Tournament" value="0" />
              </TabList>
            </Box>
            {leaderboardData?.length === 0 ? (
              <p className="text-center text-danger mt-4">Data not found.</p>
            ) : (
              <>
                <TabPanel value="1">
                  <table className="table table-borderless mb-0">
                    <thead>
                      <tr className="text-uppercase">
                        <th className="pl-3">Rank</th>
                        <th>Winner Name</th>
                        <th className="pr-3">Points</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaderboardData.map((data, index) => (
                        <tr key={data.id}>
                          <td className="pl-3">
                            {data.rank === 1 ? (
                              <img
                                src="../images/iplContest/Gold.png"
                                alt="Gold"
                              />
                            ) : data.rank === 2 ? (
                              <img
                                src="../images/iplContest/Silver.png"
                                alt="Silver"
                              />
                            ) : data.rank === 3 ? (
                              <img
                                src="../images/iplContest/Bronze.png"
                                alt="Bronze"
                              />
                            ) : (
                              data.rank
                            )}
                          </td>
                          <td>
                            {data?.winnerName.toUpperCase()} <br />{" "}
                            {data?.mobileNumber}
                          </td>
                          <td className="pr-3">{data?.scoredPoint}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </TabPanel>

                <TabPanel value="0">
                  <table className="table table-borderless mb-0">
                    <thead>
                      <tr className="text-uppercase">
                        <th className="pl-3">Rank</th>
                        <th>Winner Name</th>
                        <th className="pr-3">Points</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaderboardData.map((data, index) => (
                        <tr key={data.id}>
                          <td className="pl-3">
                            {data?.rank === 1 ? (
                              <img
                                src="../images/iplContest/Gold.png"
                                alt="Gold"
                              />
                            ) : data?.rank === 2 ? (
                              <img
                                src="../images/iplContest/Silver.png"
                                alt="Silver"
                              />
                            ) : data?.rank === 3 ? (
                              <img
                                src="../images/iplContest/Bronze.png"
                                alt="Bronze"
                              />
                            ) : (
                              data?.rank
                            )}
                          </td>
                          <td>
                            {data?.winnerName.toUpperCase()} <br />{" "}
                            {data?.mobileNumber}
                          </td>
                          <td className="pr-3">{data?.scoredPoint}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </TabPanel>
              </>
            )}
          </TabContext>
        </Box>
      </div>
      {leaderboardData?.length === 0 ? (
        ""
      ) : (
        <div className="text-center">
          <Link
            to="/Leaderboard"
            state={{
              mobileNo: userData?.mobileNo,
              ottsmsid: userData?.ottsmsid,
            }}
            className="viewAll btn"
          >
            View All
          </Link>
        </div>
      )}
    </div>
  );
};
